module.exports = __webpack_public_path__ + "img/p3-active.ddec88d8.png";